(function() {
  'use strict';

  function getMenuButton() {
    return document.querySelector('.header-type-4 .mobile-btn');
  }

  function setMenuState(open) {
    if (!document.body) return;

    document.body.classList.toggle('mobile-menu-open', open);
    if (!open) {
      document.body.classList.remove('mobile-sidebar-open');
    }

    var button = getMenuButton();
    if (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('.header-type-4 .mobile-btn');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setMenuState(!document.body.classList.contains('mobile-menu-open'));
  }, true);

  document.addEventListener('click', function(event) {
    var overlay = event.target.closest && event.target.closest('.mobile-menu-overlay');
    if (!overlay) return;
    setMenuState(false);
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      setMenuState(false);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    var button = getMenuButton();
    if (!button) return;

    button.setAttribute('aria-expanded', document.body.classList.contains('mobile-menu-open') ? 'true' : 'false');
    button.setAttribute('aria-label', document.body.classList.contains('mobile-menu-open') ? 'Close menu' : 'Open menu');
  });
})();
